import { memo } from 'react';

import { useLanguage } from 'assets/languages';
import CampaignFormFieldGroup from '../../../../../campaignFormFieldGroup/campaignFormFieldGroup';
import TagField from '../../../formFields/tagField/tagField';

const TagFieldGroup = () => {
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.campaigns };

  return (
    <CampaignFormFieldGroup
      wrapperClassName="!gap-[30px]"
      label={`5. ${languageTexts.create_reels_form_tag_guideline}`}
    >
      {/* 브랜드의 인스타그램 공식 계정 */}
      <TagField
        tagFieldName="AT_TAGS"
        label={languageTexts.create_reels_form_at_tag}
        addButtonText={`${languageTexts.add2} +`}
      />

      {/* 포스팅 시 삽입할 #태그 */}
      <TagField
        tagFieldName="HASH_TAGS"
        label={languageTexts.create_reels_form_hash_tag}
        placeholder={languageTexts.create_reels_form_placeholder_hash_tag}
        addButtonText={`${languageTexts.add2} +`}
      />
    </CampaignFormFieldGroup>
  );
};

export default memo(TagFieldGroup);
